import { render, staticRenderFns } from "./ipagesTail.vue?vue&type=template&id=e5f0b214&scoped=true&"
import script from "./ipagesTail.vue?vue&type=script&lang=js&"
export * from "./ipagesTail.vue?vue&type=script&lang=js&"
import style0 from "./ipagesTail.vue?vue&type=style&index=0&id=e5f0b214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0b214",
  null
  
)

export default component.exports